import { useReducer } from "react";

import { getDefaultVariantStore } from "./getDefaultVariantStore";
import {
  changeVariantQuantity,
  decreaseVariantQuantity,
  increaseVariantQuantity,
  selectVariant,
  variantReducer,
} from "./variantReducer";

import type { VariantCategories } from "./Variant/variantCategories";

type Input = {
  variantCategories: VariantCategories;
};
type Output = {
  handleChangeAmount: (amount: number) => void;
  handleDecreaseAmount: () => void;
  handleIncreaseAmount: () => void;
  handleSelectVariant: (variantId: number | undefined) => void;
  selectedVariantId: number | undefined;
  variantAmount: number;
};
type UseVariant = (input: Input) => Output;

export const useVariant: UseVariant = (input) => {
  const { variantCategories } = input;
  const [{ amounts, selectedVariantId }, dispatch] = useReducer(
    variantReducer,
    getDefaultVariantStore({ variantCategories })
  );
  const variantAmount =
    selectedVariantId === undefined ? 0 : (amounts.get(selectedVariantId) ?? 0);
  const handleSelectVariant = (variantId: number | undefined) => {
    if (variantId === undefined) return;
    dispatch(selectVariant(variantId));
  };
  const handleIncreaseAmount = () => {
    if (selectedVariantId === undefined) return;
    dispatch(increaseVariantQuantity(selectedVariantId));
  };
  const handleDecreaseAmount = () => {
    if (selectedVariantId === undefined) return;
    dispatch(decreaseVariantQuantity(selectedVariantId));
  };
  const handleChangeAmount = (amount: number) => {
    if (selectedVariantId === undefined) return;
    dispatch(changeVariantQuantity(selectedVariantId, amount));
  };

  return {
    handleChangeAmount,
    handleDecreaseAmount,
    handleIncreaseAmount,
    handleSelectVariant,
    selectedVariantId,
    variantAmount,
  };
};
